import axios from 'axios';

const types = {
  SENT: 'SENT',
  SEND_ERROR: 'SEND_ERROR',
  CHECK_ERROR: 'CHECK_ERROR',
  VALID: 'VALID',
  RESET: 'RESET',
};

export const sendSms = phoneNumber => (dispatch) => {
  axios
    .post('/verify/sms/send', {
      phone_number: phoneNumber,
      via: 'sms',
      country_code: 1,
      code_length: 5,
      locale: 'en',
    })
    .then((response) => {
      const { data } = response;
      if (data.codeSent) {
        dispatch(sent());
      } else {
        dispatch(sendError(data.message));
      }
    })
    .catch((error) => {
      if (error.response) {
        dispatch(sendError(error));
      } else if (error.request) {
        dispatch(sendError(error));
      } else {
        dispatch(sendError(error));
      }
    });
};

export const checkSms = ({ phoneNumber, code, userId }) => (dispatch) => {
  const sentData = {
    phone_number: phoneNumber,
    verification_code: code,
    country_code: 1,
  };

  axios
    .post('/verify/sms/check', sentData)
    .then((response) => {
      const { data } = response;
      if (data.success) {
        dispatch(valid(true));
      } else if (data.errors) {
        dispatch(valid(false));
        dispatch(checkError(data.message));
      }
    })
    .catch((error) => {
      if (error.response) {
        const { data } = error.response;
        if (data.error_code === '60023') {
          // This is the error code Twilio sends when the phone number has already been verified.
          dispatch(valid(true));
          dispatch(checkError('Number has already been verified'));
        } else {
          dispatch(valid(false));
          dispatch(checkError(data.message));
        }
      } else if (error.request) {
        dispatch(valid(false));
        dispatch(checkError('Problem with network request'));
      } else {
        dispatch(valid(false));
        dispatch(checkError(error.message));
      }
    });
};

export const reset = () => ({
  type: types.RESET,
});

const sent = () => ({
  type: types.SENT,
});
const sendError = error => ({
  type: types.SEND_ERROR,
  error,
});
const checkError = error => ({
  type: types.CHECK_ERROR,
  error,
});
const valid = valid => ({
  type: types.VALID,
  valid,
});
